import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enJson from './en.json';
import arJson from './ar.json'; // استيراد ملف الترجمة العربية

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: enJson },
            ar: { translation: arJson }, // إضافة اللغة العربية
        },
        lng: 'ar', // اللغة الافتراضية (يمكنك تعديلها إلى "ar" للعربية)
        fallbackLng: 'en', // اللغة الاحتياطية إذا كانت الترجمة غير متوفرة
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
